import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'
import { unixFromNow } from '../../../utils'

const state = {
  list: []
}

const actions = {
  [aTypes.CONTACT_GET_CONTACT_REMARKS] ({ commit }, id) {
    commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT_REMARKS, loading: true })
    api.contact.getContactNote({
      success (res) {
        const data = res.body
        const list = data.map(item => {
          return {
            name: item.title,
            content: item.content,
            update: unixFromNow(item.update_time),
            user: item.user ? item.user.realname : ''
          }
        })
        commit(mTypes.CONTACT_SET_CONTACT_REMARKS, list)
        commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT_REMARKS, loading: false })
      },
      commit
    }, id)
  }
}

const mutations = {
  [mTypes.CONTACT_SET_CONTACT_REMARKS] (state, list) {
    state.list = list
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/contact/remark.js